export const ShopSlug = 'shop';

export function getShopUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${ShopSlug}`;
}
